<template>
  <v-form @submit.prevent="activate">
    <v-text-field
      v-model="email"
      label="Account Email"
      type="email"
      prepend-inner-icon="mdi-email-outline"
      density="comfortable"
      variant="outlined"
      readonly
      class="mb-3"
    />

    <v-text-field
      v-model="token"
      label="Verification Token"
      prepend-inner-icon="mdi-key-outline"
      density="comfortable"
      variant="outlined"
      readonly
      class="mb-4"
    />

    <v-btn
      type="submit"
      color="primary"
      size="large"
      block
      class="btn-modern font-weight-bold text-white mb-2"
      :loading="loading"
      prepend-icon="mdi-check-decagram"
    >
      Activate Account
    </v-btn>

    <v-snackbar
      v-model="showSnackbar"
      :timeout="5000"
      color="success"
      location="top"
      rounded="lg"
    >
      <div class="d-flex align-center">
        <v-icon class="mr-2">mdi-check-circle</v-icon>
        {{ successMessage }}
      </div>
      <template #actions>
        <v-btn color="white" variant="text" @click="showSnackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>

    <v-snackbar
      v-model="showErrorSnackbar"
      :timeout="5000"
      color="error"
      location="top"
      rounded="lg"
    >
      <div class="d-flex align-center">
        <v-icon class="mr-2">mdi-alert-circle</v-icon>
        {{ errorMessage }}
      </div>
    </v-snackbar>
  </v-form>
</template>

<script>
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'

export default {
  name: 'AccountForm',
  props: {
    token: {
      type: String,
      required: true,
    },
    email: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const store = useStore()
    const router = useRouter()

    const email = ref(props.email)
    const token = ref(props.token)
    const loading = ref(false)
    const showSnackbar = ref(false)
    const showErrorSnackbar = ref(false)
    const successMessage = ref('')
    const errorMessage = ref('')

    const activate = async () => {
      loading.value = true
      try {
        await store.dispatch('auth/activate', {
          token: token.value,
          email: email.value,
        })
        successMessage.value = 'Your account has been activated! Redirecting to login...'
        showSnackbar.value = true
        setTimeout(() => {
          router.push('/login')
        }, 3000)
      } catch (error) {
        console.error('Activation failed:', error)
        errorMessage.value = error.message || 'Failed to activate account. Please check the token.'
        showErrorSnackbar.value = true
      } finally {
        loading.value = false
      }
    }

    return {
      email,
      token,
      loading,
      activate,
      showSnackbar,
      showErrorSnackbar,
      errorMessage,
      successMessage,
    }
  },
}
</script>